<template>
  <div class="container">
    <div class="columns is-mobile">
      <div class="column is-8">
        <h1 class="title logo">
          <strong>SIGMA</strong>WEB
          <p>WEB • MADE • SIMPLE</p>
        </h1>
      </div>
      <div class="column has-text-right">
        <a href="#contact" class="button is-primary contact">Get in Touch</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.logo {
  font-family: "Lato", sans-serif;
  font-weight: 300;
  font-size: 36px;
  strong {
    font-weight: 600;
  }
  p {
    font-size: 16px;
  }
}
.container {
  $padding: 12px;
  padding-top: $padding;
  padding-bottom: $padding;

  .button {
    &.contact {
      margin-top: $padding;
    }
  }
}
</style>

